import React from 'react';
import { Route, Routes as RouterRoutes, Navigate, useResolvedPath } from 'react-router-dom';

export const Routes = (props) => {
  const { routes, defaultRoute } = props;

  // Use React Router's context to convert absolute paths to relative
  const basePath = useResolvedPath('.').pathname;

  const toRelativePath = (absPath) => {
    if (!absPath) return absPath;
    if (basePath && basePath !== '/' && absPath.startsWith(basePath)) {
      const rest = absPath.substring(basePath.length);
      if (rest === '' || rest.startsWith('/')) {
        return rest.startsWith('/') ? rest.substring(1) : rest;
      }
    }
    if (basePath === '/' && absPath.startsWith('/')) {
      return absPath.substring(1);
    }
    return absPath;
  };

  const relativeDefault = toRelativePath(defaultRoute) ?? defaultRoute;

  return (
    <RouterRoutes>
      {routes.map((route, index) => {
        const { component: RouteComponent, routes, exact, path } = route;
        const relativePath = toRelativePath(path);
        const routePath = exact ? (relativePath || '') : `${relativePath || ''}/*`;
        return <Route
          key={index}
          path={routePath}
          element={<RouteComponent {...props} routes={routes} />} />;
      })}
      <Route path="*" element={<Navigate to={relativeDefault || '.'} replace />} />
    </RouterRoutes>
  );
}